import React from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { api } from "../../lib/api";

export function ShippingCard({ order, orderId, onRefreshed }) {
    const refresh = async () => {
        try {
            await api.post(`/orders/${orderId}/refresh_shipping`);
            const { data } = await api.get(`/orders/${orderId}`);
            onRefreshed?.(data);
        } catch (e) {
            // Visible user feedback — silent failures hide real network/auth issues
            toast.error(e?.response?.data?.detail || "Could not refresh shipping. Try again in a moment.");
        }
    };

    const statusLabel =
        order.lulu_status || (order.status === "shipped" ? "SHIPPED" : "In production");

    return (
        <div data-testid="sf-order-shipping" className="paper-card rounded-3xl p-6 md:p-8 mb-12">
            <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
                <h2 className="font-serif text-2xl text-primary">Shipping</h2>
                <Button
                    variant="outline"
                    size="sm"
                    className="rounded-xl"
                    data-testid="sf-order-refresh-shipping"
                    onClick={refresh}
                >
                    <Loader2 className="w-3.5 h-3.5 mr-2" /> Refresh status
                </Button>
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
                <div>
                    <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Print status</p>
                    <p className="font-serif text-lg text-foreground mt-1">{statusLabel}</p>
                </div>
                <div>
                    <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Carrier</p>
                    <p className="font-serif text-lg text-foreground mt-1">{order.lulu_carrier || "—"}</p>
                </div>
                <div className="sm:col-span-2">
                    <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Tracking number</p>
                    <p className="font-mono text-base text-foreground mt-1 break-all">
                        {order.lulu_tracking_id || "Available once shipped"}
                    </p>
                </div>
            </div>
            {order.lulu_tracking_url && (
                <a
                    href={order.lulu_tracking_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="sf-order-tracking-link"
                    className="inline-block mt-5"
                >
                    <Button className="rounded-xl bg-primary text-primary-foreground hover:bg-primary/90">
                        Track package
                    </Button>
                </a>
            )}
        </div>
    );
}
